import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 6A1.5 1.5 0 003 7.5v9A1.5 1.5 0 004.5 18h15a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0019.5 6h-15zm-3 1.5a3 3 0 013-3h15a3 3 0 013 3v9a3 3 0 01-3 3h-15a3 3 0 01-3-3v-9z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 6A1.5 1.5 0 003 7.5v9A1.5 1.5 0 004.5 18h15a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0019.5 6h-15zm-3 1.5a3 3 0 013-3h15a3 3 0 013 3v9a3 3 0 01-3 3h-15a3 3 0 01-3-3v-9z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.355 26.035c-1.708-1.254-.404-3.76.058-4.51-.834.918-1.666 1.834-2.314 2.836-1.018 1.564-1.454 3.282-.766 4.382 1.236 1.988 4.208 1.07 6.1.27L36 21.601l-17.354 4.586c-1.456.378-2.626.326-3.29-.152z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 12c-1.656 0-3 1.344-3 3v18c0 1.656 1.344 3 3 3h30c1.656 0 3-1.344 3-3V15c0-1.656-1.344-3-3-3H9zm-6 3c0-3.312 2.688-6 6-6h30c3.312 0 6 2.688 6 6v18c0 3.312-2.688 6-6 6H9c-3.312 0-6-2.688-6-6V15z",
    clipRule: "evenodd"
  }))
};
export var GiftCard = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});